/**
 * Returns a function that skips its first call
 * @param fn - The original function
 * @returns A new function that skips its first call
 */
export function skipFirstCall<T extends any[]>(fn: (...args: T) => void): (...args: T) => void {
    let firstCalled = false;
    return (...args: T) => {
        if (!firstCalled) {
            firstCalled = true;
            return;
        }
        fn(...args);
    }
}